import React from 'react';
import {Radio} from 'antd';
import commonRefHOC from '../../commonRefHOC';

const RadioGroup = Radio.Group;
export default commonRefHOC(RadioGroup);